import React, { useState, useEffect } from 'react'
import {
  Container,
  Image,
  TextTitle,
  TextBody,
  Button,
  Icon
} from '@pdrj/pmi-iqos-ds-react'
import {
  analytics,
  getBase64FromImg,
  htmlTranslation
} from '@pdrj/pmi-iqos-shared-react'

const PhotoUpload = ({
  data,
  setPhoto,
  getPhoto,
  errors,
  questProps,
  translations
}) => {
  const [photoErrors, setPhotoErros] = useState(errors)

  useEffect(() => {
    setPhotoErros(errors)
  }, [errors])

  let fileInputEl = null
  const triggerInputFile = () => {
    analytics.uploadPhotoEvent(questProps.id, questProps.editionId)

    fileInputEl.click()
  }

  const saveImage = async (files, id) => {
    const photoInfo = files[0]
    // Only images
    if (photoInfo && photoInfo.type && !photoInfo.type.match(/image-*/)) {
      setPhotoErros(errors.concat([translations.tk_invalidImageFormat]))
      return
    }
    // 10 Megabyte
    if (photoInfo && photoInfo.size >= 10000000) {
      setPhotoErros(errors.concat([translations.tk_imageOver10MBError]))
      return
    }
    const img = URL.createObjectURL(photoInfo)
    const uploadCb = convertedImg => {
      setPhoto({ blob: img, image: convertedImg }, id)
    }
    await getBase64FromImg(photoInfo, uploadCb)
    setPhotoErros(errors)
  }

  return (
    <Container
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.column}
      fullWidth>
      <Container
        py="6"
        px="4"
        borderColor={Container.borderColors.primary}
        fullWidth>
        <Container pb="1" fullWidth>
          <TextTitle heading={TextTitle.headings.h6}>{data.heading}</TextTitle>
        </Container>
        <Container pb="6" fullWidth>
          <TextBody value={data.label} />
        </Container>
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          alignItems={Container.alignItemsValues.center}
          fullWidth>
          <Container fullWidth>
            <input
              ref={fileInput => (fileInputEl = fileInput)}
              type="file"
              accept="image/*"
              onClick={e => (e.target.value = null)}
              onChange={e => saveImage(e.target.files, data.id)}
              style={{ display: 'none' }}
            />
            <Container>
              {getPhoto ? (
                <Container
                  onClickHandler={triggerInputFile}
                  fullWidth
                  p="10"
                  display={Container.displays.flex}
                  justifyContent={Container.justifyContentValues.center}>
                  <Image src={getPhoto || ''} alt="post-picture" />
                </Container>
              ) : (
                <>
                  <Container
                    fullWidth
                    py="12"
                    display={Container.displays.flex}
                    justifyContent={Container.justifyContentValues.center}
                    bg={Container.backgrounds.hardWhite}
                    onClickHandler={triggerInputFile}
                    borderColor={Container.borderColors.slate30}>
                    <Icon image={Icon.images.upload} />
                  </Container>
                  <TextBody {...htmlTranslation('tk_photoTooBig')} />
                </>
              )}
            </Container>
          </Container>
          {(photoErrors || []).map((e, i) => {
            return (
              <Container key={i} pt="1" fullWidth>
                <TextBody
                  size={TextBody.sizes.xs}
                  style={TextBody.styles.error}>
                  {e}
                </TextBody>
              </Container>
            )
          })}
          <Container
            pt="4"
            fullWidth
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.center}>
            <Button
              variant={Button.variants.primary}
              text={translations.tk_uploadButton}
              onClickHandler={triggerInputFile}
              data-testing="Button_UploadImage"
            />
          </Container>
        </Container>
      </Container>
    </Container>
  )
}

export default PhotoUpload
